import { alertError, alertSuccess } from './alert';
import { putUser } from './api/users';
import { setRoleUser } from './roles';
import { LOAD_USER_NOTIFICATIONS } from '../constants/rolesTypes';

export const updateUser = (userId, data) => async (dispatch, getState) => {
  const { user } = getState().role;

  try {
    const response = await putUser(userId, data);
    if (response.data.success) {
      dispatch(alertSuccess('User updated'));

      // Update saved user in `roles` state
      dispatch(
        setRoleUser({
          ...user,
          ...data,
        }),
      );
    } else {
      dispatch(alertError('Error updating user'));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const updateCurrentUser = (data) => async (dispatch, getState) => {
  const { user } = getState().role;
  dispatch(updateUser(user.id, data));
};

export const updateLoadingNotifications = (isLoading = false) => ({
  type: LOAD_USER_NOTIFICATIONS,
  payload: isLoading,
});
